import React from "react";

import { Plus } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router-dom";

import { Button } from "@/src/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/src/components/ui/dropdown-menu";
import { AdvertisingEnum } from "@/src/types/advertisings";

import { ADVERTISING_TYPE_ICONS } from "./advertisingTypeIcons";
import { PROJECTS_ROUTE } from "../routes/routes";

import type { JSX } from "react";

function CreateAdvertisingsButton(): JSX.Element {
  const { t } = useTranslation("editor-advertisings");
  const history = useHistory();
  const { projectSlug } = useParams<{ projectSlug: string }>();

  const handleCreate = (type: AdvertisingEnum): void => {
    history.push(`${PROJECTS_ROUTE}/${projectSlug}/advertisings/new/${type}`);
  };

  const handleCreateMp4 = (): void => handleCreate(AdvertisingEnum.CSAI_MP4);

  const handleCreateVast = (): void => handleCreate(AdvertisingEnum.CSAI_VAST);

  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <Button size="lg" type="button">
          <Plus />
          {t("createAdvertising")}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onSelect={handleCreateMp4}>
          <ADVERTISING_TYPE_ICONS.csai_mp4 />
          {t("CSAIMP4")}
        </DropdownMenuItem>
        <DropdownMenuItem onSelect={handleCreateVast}>
          <ADVERTISING_TYPE_ICONS.csai_vast />
          {t("CSAIVast")}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export default CreateAdvertisingsButton;
